export const RELEASE_DOCUMENT = "Release Document";
export const RELEASE_DOCUMENT_TOOLTIP = "The document will be checked in and released";
export const DELETE_ONEDRIVE_DOC = "Delete OneDrive original";
export const DELETE_ONEDRIVE_DOC_TOOLTIP =
  "Once the document is checked in, the original file will be deleted from OneDrive.";
export const ONEDRIVE_DOCUMENT_DELETED = "OneDrive document will be deleted";